import { getVacationStatusById } from "./lib";

export const vacationStatus = (id, vacationStatuses) => getVacationStatusById(id,vacationStatuses).name
